import React from "react";

const Typing = () => (
  <div className="typing">
    <div className="typing__dot" />
    <div className="typing__dot" />
    <div className="typing__dot" />
  </div>
);

export default Typing;
